module.exports = __webpack_public_path__ + "img/life.46e47a99.jpg";